module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.external-services')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "external-services",
      "columns": ['id', 'type', 'url'],
      "sModel": "external-service"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d1bc039!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external-service/ExternalServiceList.vue
// module id = 1153
// module chunks = 2